import { render, staticRenderFns } from "./news8.vue?vue&type=template&id=e7c23d8e&scoped=true&"
import script from "./news8.vue?vue&type=script&lang=js&"
export * from "./news8.vue?vue&type=script&lang=js&"
import style0 from "./news8.vue?vue&type=style&index=0&id=e7c23d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c23d8e",
  null
  
)

export default component.exports